import { render, staticRenderFns } from "./requestImmPass.vue?vue&type=template&id=3b06f234&scoped=true&"
import script from "./requestImmPass.vue?vue&type=script&lang=js&"
export * from "./requestImmPass.vue?vue&type=script&lang=js&"
import style0 from "./requestImmPass.vue?vue&type=style&index=0&id=3b06f234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b06f234",
  null
  
)

export default component.exports